<template>
  <div>
    <el-form size="mini" :model="customer" :rules="rules" ref="ruleForm" label-width="135px">
      <div  style="max-height: 600px;overflow: auto">
        <el-row>
          <el-col>
            <el-form-item label="客户基础信息"></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称" prop="customerName">
              <el-input style="width: 100%" v-model="customer.customerName" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="跟进人" prop="gjr">
              <el-input  style="width: 100%" readonly v-model="customer.gjr" size="small">
                <i @click="gjrModel = true" slot="suffix"  class="el-icon-plus"></i>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户类型" prop="customerType">
              <el-select  size="small" style="width: 100%" v-model="customer.customerType" placeholder="请选择">
                <el-option :value="1" label="物业公司（发展商，业委会）"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在省市" prop="city">
              <chooseCity v-if="isUpdate == false"  style="width: 100%" @choseProvince="choseProvince" @choseCity="choseCity" :is-area="false"></chooseCity>
              <el-input disabled v-if="isUpdate == true" v-model="customer.city" size="small" style="width: 70%" />
              <el-button size="small" v-if="isUpdate == true" @click="() => {isUpdate = false}">修改</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="客户联系人信息"></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contacts">
              <el-input  style="width: 100%"  v-model="customer.contacts" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input  style="width: 100%"  v-model="customer.phone" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="tel">
              <el-input  style="width: 100%"  v-model="customer.tel" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="开户行信息">
              <el-button icon="el-icon-plus" @click="addOpenBank()">添加</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-table
            ref="multipleTable"
            :data="openBankInformation"
            tooltip-effect="dark"
            width="100%"
          >
            <el-table-column prop="openName" label="开户名称">
              <template slot-scope="scope">
                <el-input v-if="scope.row.openBankStatus" v-model="scope.row.openName" size="small"/>
                <span v-else>{{scope.row.openName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="accountNumber" label="账号">
              <template slot-scope="scope">
                <el-input v-if="scope.row.openBankStatus" v-model="scope.row.accountNumber" size="small"/>
                <span v-else>{{scope.row.accountNumber}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="openBank" label="开户行">
              <template slot-scope="scope">
                <el-input v-if="scope.row.openBankStatus" v-model="scope.row.openBank" size="small"/>
                <span v-else>{{scope.row.openBank}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button v-if="scope.row.deleteButtonShow" size="mini" type="text" @click="removeOpenBank(scope.row)">删除</el-button>
                <el-button v-if="scope.row.deleteButtonShow" size="mini" type="text" @click="updateOpenbank(scope.row)">{{scope.row.buttonName}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>
      <el-row>
        <el-col>
          <el-form-item style="float: right">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button type="primary" size="small" @click="submit('ruleForm')">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      title="选择跟进人"
      append-to-body
      :visible.sync="gjrModel"
      width="800px">
      <chooseUser @chooseCancel="gjrModel = false" @chooseOk="chooseUserOk"></chooseUser>
    </el-dialog>
  </div>
</template>
<script>
import { createCustomer, updateCustomer } from '@/api/resource'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  props: {
    isUpdate: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      gjrModel: false,
      customer: {},
      rules: {
        customerName: [
          {required: true, message: '请输入客户名称', trigger: 'blur'}
        ],
        customerType: [
          {required: true, message: '请选择客户类型', trigger: 'blur'}
        ],
        gjr: [
          {required: true, message: '请选择跟进人', trigger: 'blur'}
        ],
        contacts: [
          {required: true, message: '请输入联系人', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        tel: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        city: [
          {required: true, message: '请选择省市', trigger: 'blur'}
        ]
      },
      openBankInformation: [{
        id: '',
        openName: '',
        accountNo: '',
        openBank: '',
        deleteButtonShow: false,
        openBankStatus: false,
        buttonName: '修改'
      }]
    }
  },
  created () {
    if (this.isUpdate === false) {
      this.openBankInformation = []
      this.customer = {
        allOpenBankValue: [],
        customerName: '',
        customerType: '',
        province: '',
        city: '',
        gjrId: '',
        gjr: '',
        contacts: '',
        phone: '',
        tel: ''
      }
    }
    if (this.isUpdate) {
      this.customer.gjr = ''
    }
  },
  methods: {
    cancel () {
      this.openBankInformation = []
      this.customer = {
        customerName: '',
        customerType: '',
        province: '',
        city: '',
        gjrId: '',
        contacts: '',
        phone: '',
        tel: '',
        openName: '',
        openBank: '',
        accountNumber: ''
      }
      this.$emit('cancelInsertCustomer')
    },
    submit (formName) {
      this.customer.allOpenBankValue = this.openBankInformation
      this.$refs[formName].validate((valid) => {
        if (valid) {
          for (var a = 0; a < this.customer.allOpenBankValue.length; a++) {
            if (this.customer.allOpenBankValue[a].openName === '' ||
              this.customer.allOpenBankValue[a].openBank === '' ||
              this.customer.allOpenBankValue[a].accountNumber === '' ||
              this.customer.allOpenBankValue[a].openName === undefined ||
              this.customer.allOpenBankValue[a].openBank === undefined ||
              this.customer.allOpenBankValue[a].accountNumber === undefined
            ) {
              return this.$notify({
                title: '警告',
                message: '请完整输入开户行信息',
                type: 'warning'
              })
            }
          }
          if (this.isUpdate === false) {
            createCustomer(this.customer).then(res => {
              this.$emit('addComplete')
            })
          }
          if (this.isUpdate === true) {
            updateCustomer(this.customer).then(res => {
              this.$emit('updateComplete')
            })
          }
        }
      })
    },
    choseProvince (e, shi) {
      this.customer.province = e
      this.customer.city = shi
    },
    choseCity (e) {
      this.customer.city = e
    },
    chooseUserOk (val) {
      this.customer.gjr = val.fullName
      this.customer.gjrId = val.id
      this.gjrModel = false
    },
    removeOpenBank (val) {
      if (this.openBankInformation.length > 0) {
        this.openBankInformation.splice(this.openBankInformation.indexOf(val), 1)
      } else {
        return this.$notify({
          title: '警告',
          message: '没有开户行数据',
          type: 'warning'
        })
      }
    },
    addOpenBank () {
      this.openBankInformation.push({
        id: '',
        openName: '',
        accountNo: '',
        openBank: '',
        status: 1,
        deleteButtonShow: true,
        openBankStatus: true,
        buttonName: '保存'
      })
    },
    updateOpenbank (row) {
      if (row.openName !== null && row.openName !== undefined && row.openName !== '') {
        if (row.openBankStatus) {
          this.$set(row, 'openBankStatus', false)
          this.$set(row, 'buttonName', '修改')
        } else {
          this.$set(row, 'openBankStatus', true)
          this.$set(row, 'buttonName', '保存')
        }
      } else {
        return this.$notify({
          title: '警告',
          message: '请填写开户行信息',
          type: 'warning'
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/insert_customer/index.vue